<template>
    <vx-dropdown
        v-bind="$attrs"
        ref="dropdown"
        menu-class="date-dropdown-menu"
        :open-on-click="true"
    >
        <template v-slot="{ visible }">
            <slot :visible="visible" :value="localValue">
                <vx-action-icon
                    :icon="!visible ? 'CalendarIcon' : 'XIcon'"
                    :hover-icon="!visible ? 'CalendarIcon' : 'XIcon'"
                    :hover-color="!visible ? 'primary' : 'danger'"
                    :active-color="!visible ? 'primary' : 'danger'"
                    :active="!!value"
                    @click="tryClear($event, visible)"
                />
            </slot>
        </template>
        <template v-slot:menu>
            <div class="p-2">
                <slot name="top"></slot>
                <div class="flex justify-between">
                    <slot name="left"> </slot>

                    <date-picker
                        ref="calendar"
                        v-model="localValue"
                        mode="time"
                        :attributes="attributes_x"
                        :disabled-dates="disabledDates"
                        :available-dates="availableDates"
                        :is-dark="isThemeDark"
                    />
                    <slot name="right"></slot>
                </div>
                <slot name="bottom"></slot>
            </div>
        </template>
    </vx-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { DatePicker } from 'v-calendar'

export default {
    name: 'vx-time-dropdown',
    components: {
        DatePicker
    },
    props: {
        value: {
            type: [Date, String]
        },
        attributes: {
            type: Array,
            default: () => []
        },
        disabledDates: {
            type: [Object, Array]
        },
        availableDates: {
            type: [Object, Array]
        },
        closeOnSelect: {
            type: Boolean
        }
    },
    watch: {
        localValue(newV) {
            if (!newV || !this.$refs.calendar) {
                return
            }
            this.$refs.calendar.move(newV)
        }
    },
    data() {
        return {
            now: new Date().getStartOfDay()
        }
    },
    computed: {
        ...mapGetters({
            isThemeDark: 'theme/isThemeDark'
        }),
        localValue: {
            get() {
                if (!this.value) {
                    return null
                }

                return new Date(this.value)
            },
            set(val) {
                this.$emit('input', val)

                if (!this.closeOnSelect) {
                    return
                }
                setTimeout(
                    function () {
                        this.$refs.dropdown.close()
                    }.bind(this),
                    50
                )
            }
        },
        attributes_x() {
            return [
                ...this.attributes,
                {
                    key: 'today',
                    bar: 'red',
                    dates: this.now
                }
            ]
        },
        dateString() {
            if (!this.localValue) {
                return 'No Date Set'
            }
            return new Date(this.localValue).toLocaleDateString('en-AU')
        }
    },
    methods: {
        tryClear(e, visible) {
            if (!visible) {
                return
            }
            e.preventDefault()
            this.localValue = null
        }
    }
}
</script>

<style lang="scss">
.date-dropdown-menu {
    .vc-container {
        background-color: transparent;
        border: none !important;
    }
}
</style>
